<template>
    <div class="fabric-wrap section-wrap">
        <div class="fabric-box">
            <div class="title-price">
                <span>面料定制</span>
                <span>{{fabric_plus_price}}</span>
            </div>
            <!--        <div class="fabric-title">面料</div>-->
            <div class="fabric-color">
                <div class="color-item" :key="index"
                     :class="{
                active: unique_key == `${color.fabric_key}${color.color_key}${color.color_value}`,
                'select-active':unique_key == `${color.fabric_key}${color.color_key}${color.color_value}`}"
                     v-for="(color, index) in color_list"  @click="change_tip(color.color_value, color.color_key, color.fabric_key)">
                    <Tooltip :content="color.fabric_name_cn" :delay="500" :max-width="200" :transfer="true">
                        <div class="color-img"  >
                            <Icon type="ios-information-circle" class="magnifier" size="18" @click.stop="mag(color.color_thumb ? color.color_thumb : color.color_value)" />
                            <img v-lazy="`${(color.color_thumb ? color.color_thumb : color.color_value) + '?x-oss-process=image/resize,w_100,h_100,m_pad,color_FFFFFF'}`" alt="" :key="'lazy-'+index">
                            <div class="shadow-box">
                                <div class="shadow-box-text">{{color.color_name_cn}}</div>
                            </div>
                        </div>
                    </Tooltip>
                    <div class="price">+￥{{color.fabric_price|price_format}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "Fabric",
        data(){
            return {

            }
        },
        computed: {
            ...mapState({
                // 款式的可选材质+布料颜色信息
                fabric_list: (state) => state.mtm.picked_category.hasOwnProperty('fabric') ? state.mtm.picked_category.fabric : Array.of(),
                // 当前选中材质
                current_fabric(state) {
                    return state.mtm.form_data.fabric_list.material
                },
                // 当前选中布料颜色
                current_color(state) {
                    return {...state.mtm.form_data.fabric_list.color, fabric_key: this.current_fabric?.fabric_key}
                },
                style_data: (state) => state.mtm.form_data.customize_data,
            }),
            // 选项的唯一标识，拼接
            unique_key() {
                return `${this.current_fabric.fabric_key}${this.current_color.color_key}${this.current_color.color_value}`
            },
            // 款式的所有可选材质+布料颜色信息，合并为一个数组
            color_list() {
                let result = [];
                this.fabric_list.forEach((fabric_item, index) => {
                    let color_list = fabric_item.color_list
                    for(let color_index=0;color_index<color_list.length;color_index++) {
                        result.push({...color_list[color_index],
                            fabric_key: fabric_item.fabric_key,
                            fabric_name_cn:fabric_item.fabric_name_cn,
                            fabric_price: fabric_item.fabric_price
                        })
                    }
                })
                return result
            },
            fabric_plus_price() {
                let a = Math.round(this.current_fabric.fabric_price*100) / 100
                return isNaN(a) ? `` : '￥ '  + a.toFixed(2)
            }
        },
        methods: {
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            change_tip(color_value, color_key, fabric_key) {
                if(this.style_data.length) {
                    this.$Modal.confirm({
                        title: '注意',
                        content: '更换面料将清空当前文字等个性定制信息，是否继续？',
                        onOk: () => {
                            this.$store.commit('mtm/reset_customize_data')
                            this.select_color(color_value, color_key, fabric_key)
                        },
                        onCancel: () => {
                        }
                    });
                } else {
                    this.select_color(color_value, color_key, fabric_key)
                }
            },
            select_color(color_value, color_key, fabric_key) {
                let selected_fabric = this.fabric_list.find((v) => {
                    return v.fabric_key === fabric_key
                })
                let selected_color = selected_fabric.color_list.find((v) => {
                    return v.color_key === color_key && v.color_value === color_value
                })
                this.$store.commit('mtm/choose_fabric', {
                    material: selected_fabric,
                    color: selected_color
                })
            },
            colorValue(color_value) {
                if (color_value.indexOf("http") >= 0) {
                    return `background-image:url(${color_value + '?x-oss-process=image/resize,w_100,h_100,m_pad,color_FFFFFF'});background-size:cover`;
                }
                return "background:" + color_value;
            }

        },
        mounted() {
            if(Object.keys(this.current_fabric).length === 0) {
                this.select_color(this.color_list[0].color_value, this.color_list[0].color_key, this.color_list[0].fabric_key)
            }
        }
    }
</script>

<style scoped lang="scss">
    .fabric-box {
        padding-right: 20px;
        .title-price {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            color: #0f114a;
            font-weight: bold;
        }

        .fabric-title {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 18px;
            color: #333333;
            border-bottom: 1px solid #dddddd;
            padding-bottom: 10px;
            margin-top: 32px;
        }

        .fabric-item {
            margin-top: 10px;
            cursor: pointer;

            .item {
                width: 335px;
                height: 83px;
                background: #ffffff;
                border: 1px solid #dddddd;
                opacity: 1;
                border-radius: 2px;
                padding: 20px 10px;
                font-size: 13px;
                line-height: 20px;
                color: #666666;
            }

            .price {
                margin-top: 5px;
                font-size: 13px;
                font-weight: 400;
                color: #666666;
            }
        }

        .active {
            .item {
                border: 1px solid #0f114a;
            }

            .price {
                color: #0f114a;
                font-weight: bold;
            }
        }

        textarea {
            width: 335px;
            height: 80px;
            background: #f3f4f5;
            opacity: 1;
            border-radius: 2px;
            padding: 10px;
        }

        .size-color {
            margin-top: 10px;

            .color {
                width: 42px;
                height: 42px;
                border-radius: 2px;
                float: left;
                cursor: pointer;
                margin-bottom: 10px;
                margin-right: 10px;
                border: 1px solid #dddddd;
            }

            .active {
                border: 2px solid #fcd77e;
            }
        }

        .font-size-style {
            margin-top: 10px;

            .size-box {
                width: 105px;
                opacity: 1;
                border-radius: 2px;
                margin-bottom: 10px;
                margin-right: 10px;
                cursor: pointer;
                font-size: 13px;
                color: #666666;
                float: left;
                text-align: center;

                .size {
                    width: 100%;
                    height: 42px;
                    line-height: 42px;
                    text-align: center;
                    background: #f3f4f5;
                    font-size: 22px;
                    color: #333333;
                    margin-bottom: 5px;
                }
            }

            .active {
                color: #0f114a;
                font-weight: bold;
            }

            .size-box:nth-child(3n) {
                margin-right: 0px;
            }
        }

        .fabric-color {
            margin-top: 10px;

            .color-item {
                width: 105px;
                float: left;
                margin-bottom: 20px;
                margin-right: 8px;
                cursor: pointer;
                &:nth-child(8n) {
                    margin-right: 0;
                }
                .color-img {
                    position: relative;
                    width: 105px;
                    height: 105px;
                    background: rgba(0, 0, 0, 0);
                    border: 1px solid #0f114a;
                    opacity: 1;
                    border-radius: 2px;
                    .magnifier{
                        z-index: 99;
                        position: absolute;
                        bottom:5px;
                        right:5px;
                    }
                    .shadow-box {
                        width: 100%;
                        height: 27px;
                        position: absolute;
                        background: #000000;
                        opacity: 0.5;
                        bottom: 0;
                        left: 0;
                        border-radius: 0px 0px 2px 2px;

                        .shadow-box-text {
                            width: 100%;
                            height: 27px;
                            line-height: 27px;
                            text-align: center;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            color: #ffffff;
                            text-align: center;
                        }
                    }
                }

                .price {
                    text-align: center;
                    margin-top: 5px;
                    font-size: 13px;
                    font-weight: 400;
                    color: #666666;
                }
            }

            .active {
                .price {
                    color: #0f114a;
                    font-weight: bold;
                }
            }

        }
    }

</style>
